"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExpertiseLevelMetrics = void 0;
var client_1 = require("@apollo/client");
var use_app_data_1 = require("./use-app-data");
var EXPERTISE_LEVEL_METRICS_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ExpertiseLevelMetricsQuery {\n    allExpertiseLevels {\n      id\n      orderNumber\n      slug\n      name\n      peopleCount\n    }\n  }\n"], ["\n  query ExpertiseLevelMetricsQuery {\n    allExpertiseLevels {\n      id\n      orderNumber\n      slug\n      name\n      peopleCount\n    }\n  }\n"])));
var useExpertiseLevelMetrics = function () {
  return (0, use_app_data_1.useAppData)({
    query: EXPERTISE_LEVEL_METRICS_QUERY,
    queryValueKey: 'allExpertiseLevels',
    valueKey: 'expertiseLevels',
    defaultValue: []
  });
};
exports.useExpertiseLevelMetrics = useExpertiseLevelMetrics;
var templateObject_1;